import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'
import { candidatesSaga } from './candidates/sagas'

export function* candidateSaga() {
  yield all([dataSaga(), candidatesSaga()])
}
